import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FaHandshake } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../redux/reducers';
import introductionService from '../../../services/introductionService';
import ModalLayout from '../layouts/ModalLayout';
import { getUserId } from '../../../services/httpService';
import IconBadge from '../icons/IconBadge';
import CancelSaveButton from '../misc/CancelSaveButton';
import ConnectionsList from '../misc/ConnectionsList';

interface IntroductionModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  userId: number;
  alias: string;
}
export default function IntroductionModal({
  open,
  setOpen,
  userId,
  alias,
}: IntroductionModalProps) {
  const connections = useSelector((state: RootState) => state.connections);
  const { t } = useTranslation();
  const [compatible, setCompatible] = useState<number[]>([]);
  const [selected, setSelected] = useState<number[]>([]);

  useEffect(() => {
    if (!open) return;
    setSelected([]);
    introductionService
      .getCompatibleUserids(
        userId,
        connections.map((c) => c.memberId).filter((c) => c && c !== userId) as number[],
      )
      .then(setCompatible);
  }, [open]);

  // const handleChange = (changedId: number) => {
  //   if (selected.includes(changedId)) setSelected(selected.filter((i) => i !== changedId));
  //   else setSelected([...selected, changedId]);
  // };

  const handleSubmit = () => {
    introductionService.createIntroductions(userId, selected);
    toast.success('Introductions sent!');
    setOpen(false);
  };

  return (
    <ModalLayout
      open={open}
      setOpen={setOpen}
      className="h-a z-50 mx-6 flex w-fit min-w-[450px] max-w-[700px] flex-col rounded-[12px] bg-secondary-50 px-10 py-6 pb-4 pt-5">
      <div className="flex w-full">
        <IconBadge icon={FaHandshake} />

        <div className="mb-6 ml-4 flex w-full flex-col">
          <h1 className="text-2xl">{t('component.modal.introduction.title')}</h1>
          <span>
            {t('component.modal.introduction.subtitle', {
              name: alias.replace('+', ' '),
              firstName: alias.split('+')[0],
            })}
          </span>
        </div>
      </div>
      {open && (
        <ConnectionsList
          connections={connections
            .filter((c) => c.memberId && userId !== c.memberId && c.memberId !== +getUserId())
            .map(({ memberId: id, fields: { FIRST_NAME, LAST_NAME } }) => ({
              id,
              alias: `${FIRST_NAME}+${LAST_NAME}`,
              disabled: !compatible?.includes(id!),
            }))}
          selected={selected}
          setSelected={setSelected}
        />
      )}

      <div className="mt-6 flex w-full justify-end">
        <CancelSaveButton
          onCancel={() => setOpen(false)}
          onSave={handleSubmit}
          disabled={!selected.length}
          buttonText={t('component.modal.addAdmin.invite')}
        />
      </div>
    </ModalLayout>
  );
}
